<script setup>
import { storyblokImage } from '~/utils/storyblok-image';
import { useStoryblokVersion } from '~/composables/use-storyblok-version';

const storyblokApi = useStoryblokApi();
const { language } = useMarket();

const { data } = await storyblokApi.get('cdn/stories/global/error-page', {
    version: useStoryblokVersion(),
    resolve_links: 'url',
    language: language.value,
});

const blok = ref(null);
blok.value = data.story.content.global[0];
</script>

<template>
    <div class="page">
        <TopNavigation />
        <section class="bg-white dark:bg-midnight-blue">
            <div class="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
                <div class="mx-auto max-w-screen-sm text-center">
                    <img
                        class="mx-auto mb-4"
                        :src="storyblokImage(blok.image.filename, { width: 1200 })"
                        alt="404 Not Found"
                    />
                    <h2 class="mb-4 leading-none text-black dark:text-white">
                        {{ blok.title }}
                    </h2>
                    <p
                        class="mt-4 text-base font-normal text-gray-500 sm:text-xl dark:text-gray-400"
                    >
                        {{ blok.description }}
                    </p>
                    <BlokLink :to="blok.ctaLink" :replace="true">
                        <button
                            class="inline-flex items-center my-4 py-3 px-5 text-base font-medium text-center rounded-lg focus:ring-4 justify-center text-white bg-primary-700 hover:bg-primary-800 focus:ring-primary-300 dark:focus:ring-primary-900"
                        >
                            {{ blok.ctaLabel }}
                        </button>
                    </BlokLink>
                </div>
            </div>
        </section>
        <Footer />
    </div>
</template>
